import { Reducer, useCallback, useReducer } from "react";
import { TagGroupFieldKeyType } from "./ObjectTagValuesConfigurationFieldTypes";

export type ObjectTagValuesConfigurationEditorState = {
    tagGroupKey: TagGroupFieldKeyType | undefined;
};

enum ObjectTagValuesConfigurationEditorActionType {
    TagGroupSelected = "TAG_GROUP_SELECTED"
}

type ObjectTagValuesConfigurationEditorAction = {
    type: ObjectTagValuesConfigurationEditorActionType.TagGroupSelected;
    tagGroupKey: TagGroupFieldKeyType | undefined;
};

const initialState: ObjectTagValuesConfigurationEditorState = {
    tagGroupKey: undefined
};

function ObjectTagValuesConfigurationEditorReducer(
    state: ObjectTagValuesConfigurationEditorState,
    action: ObjectTagValuesConfigurationEditorAction): ObjectTagValuesConfigurationEditorState {

    switch (action.type) {
        case ObjectTagValuesConfigurationEditorActionType.TagGroupSelected:
            return {
                ...state,
                tagGroupKey: action.tagGroupKey
            };

        default:
            return state;
    }
}

export type UseObjectTagValuesConfigurationEditorStateType = {
    state: ObjectTagValuesConfigurationEditorState;
    selectTagGroup: (tagGroupKey: TagGroupFieldKeyType | undefined) => void;
};

export function useObjectTagValuesConfigurationEditorState(): UseObjectTagValuesConfigurationEditorStateType {

    const [state, dispatch] = useReducer(
        ObjectTagValuesConfigurationEditorReducer,
        initialState
    );

    const selectTagGroup = useCallback((tagGroupKey: TagGroupFieldKeyType | undefined) => {
        dispatch({
            type: ObjectTagValuesConfigurationEditorActionType.TagGroupSelected,
            tagGroupKey: tagGroupKey
        });
    }, []);

    return {
        state,
        selectTagGroup: selectTagGroup
    };
}
